import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Logo from '@/components/Logo';
import { ClipboardList, LogOut, DollarSign, BookOpen } from 'lucide-react';

export default function VendorLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = user?.full_name?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() || 'V';

  return (
    <div className="min-h-screen bg-[#0F172A]">
      <nav className="sticky top-0 z-50 bg-[#140E0A]/95 backdrop-blur-xl border-b border-[#2D3F5E]">
        <div className="max-w-screen-xl mx-auto px-6 h-14 flex items-center gap-6">
          <div className="flex items-center gap-3 flex-shrink-0">
            <Logo size={28} />
            <div>
              <span className="text-white font-['Manrope'] font-extrabold text-sm">Millennials</span>
              <span className="text-[#3B82F6] font-['Manrope'] font-bold text-sm ml-1">Maintenance</span>
            </div>
            <span className="px-2 py-0.5 bg-orange-900/30 border border-orange-800/50 rounded-full text-[9px] font-['JetBrains_Mono'] uppercase tracking-wider text-orange-400">Vendor</span>
          </div>
          <NavLink to="/vendor/orders" className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 rounded-sm text-sm font-['IBM_Plex_Sans'] transition-all ${isActive ? 'text-[#3B82F6] bg-[#3B82F6]/10' : 'text-[#B8C0CC] hover:text-white'}`}>
            <ClipboardList size={14} /> Work Orders
          </NavLink>
          <NavLink to="/vendor/pricing" className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 rounded-sm text-sm font-['IBM_Plex_Sans'] transition-all ${isActive ? 'text-[#3B82F6] bg-[#3B82F6]/10' : 'text-[#B8C0CC] hover:text-white'}`}>
            <DollarSign size={14} /> My Pricing
          </NavLink>
          <div className="ml-auto flex items-center gap-3">
            <a href="/USER_MANUAL_SR.pdf" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-[#5C6A7A] hover:text-[#3B82F6] transition-colors text-xs font-['IBM_Plex_Sans']"
              title="User Manual (PDF)" data-testid="vendor-manual-link">
              <BookOpen size={14} /> <span className="hidden sm:inline">Manual</span>
            </a>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-sm bg-orange-900/30 border border-orange-800/50 flex items-center justify-center">
                <span className="text-orange-400 text-xs font-extrabold font-['Manrope']">{initials}</span>
              </div>
              <span className="text-[#B8C0CC] text-xs font-['IBM_Plex_Sans'] hidden sm:block">{user?.full_name}</span>
              <button onClick={() => { logout(); navigate('/login'); }} className="text-[#5C6A7A] hover:text-red-400 transition-colors p-1">
                <LogOut size={14} />
              </button>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-screen-xl mx-auto px-6 py-7">
        <Outlet />
      </main>
    </div>
  );
}
